export default function InputDetails(props) {
    function onChange(e) {
        props.onDataChanged(e.target.id, e.target.value);
    }

    return (
        <div className="InputDetailsContainer">
            <section>
                {/* <div>
                    <label htmlFor="walletId">Wallet ID:</label>
                    <input id="walletId" type="text" defaultValue={props.walletId} onChange={onChange}/>
                </div> */}
                <div>
                    <label htmlFor="brandId">Brand ID:</label>
                    <input id="brandId" type="text" defaultValue={props.brandId} onChange={onChange}/>
                </div>
                <div>
                    <label htmlFor="sourceId">Source ID:</label>
                    <select value={props.sourceId} id="sourceId" onChange={onChange}>
                        <option key="01" value="">-- Select --</option>
                        {props.sourceList.map((source, i) =>
                            <option key={i} value={source.source_id}>{source.source_name}</option>
                        )}
                    </select>
                </div>
                <div>
                    <label htmlFor="gameRoundId">Game Round ID:</label>
                    <input id="gameRoundId" type="text" defaultValue={props.gameRoundId} onChange={onChange}/>
                </div>
            </section>
            <section>
                <div>
                    <label htmlFor="tokenId">Token:</label>
                    <input id="tokenId" type="text" defaultValue={props.tokenId} onChange={onChange}/>
                </div>
                <div>
                    <label htmlFor="playerId">Player ID:</label>
                    <input id="playerId" type="text" defaultValue={props.playerId} onChange={onChange}/>
                </div>
                <div>
                    <label htmlFor="playerCountry">Player Country:</label>
                    <input id="playerCountry" type="text" defaultValue={props.playerCountry} onChange={onChange}/>
                </div>
            </section>
            <section>
                <div>
                    <label htmlFor="baseWager">Base Game Wager:</label>
                    <input id="baseWager" type="text" defaultValue={props.baseWager} onChange={onChange}/>
                </div>
                <div>
                    <label htmlFor="currency">Currency:</label>
                    <input id="currency" type="text" defaultValue={props.currency} onChange={onChange}/>
                </div>
            </section>
        </div>
    );
}
